// eslint-disable-next-line
export const sellerSelectConstants = {
  SELLER_SELECTED: 'SELLER_SELECTED',
  SELLER_RESET: 'SELLER_RESET',
  SELLER_SET_DEFAULT: 'SELLER_SET_DEFAULT',
};
